/**
 * pdf.js (via react-pdf) calls Promise.withResolvers(), which is only native
 * from Chrome 119 / Safari 17.4 / Firefox 121. School-managed Chrome often
 * lags; without this, PDF boxes throw and hit the lazy-route rocket screen.
 *
 * Spec: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 *
 * Captured at module load, before installPromiseWithResolversPolyfill() runs.
 * The PDF.js worker is a separate realm and does not get this polyfill.
 */
export const HAD_NATIVE_PROMISE_WITH_RESOLVERS =
  typeof Promise.withResolvers === "function";

export function installPromiseWithResolversPolyfill(promiseCtor = Promise) {
  if (typeof promiseCtor?.withResolvers === "function") {
    return false;
  }
  if (typeof promiseCtor !== "function") {
    return false;
  }

  promiseCtor.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new promiseCtor((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
  return true;
}
